import { render, staticRenderFns } from "./iybr-cost-table.vue?vue&type=template&id=705b4022"
import script from "./iybr-cost-table.ts?vue&type=script&lang=ts&external"
export * from "./iybr-cost-table.ts?vue&type=script&lang=ts&external"
import style0 from "./iybr-cost-table.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705b4022')) {
      api.createRecord('705b4022', component.options)
    } else {
      api.reload('705b4022', component.options)
    }
    module.hot.accept("./iybr-cost-table.vue?vue&type=template&id=705b4022", function () {
      api.rerender('705b4022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/iybr-cost-table/iybr-cost-table.vue"
export default component.exports